// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__2FRzg","container":"styles_container__1K_36","createType":"styles_createType__INP0i","submitModal":"styles_submitModal__VyS54"};